import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  prtActionButton: 'Spot Rate',
  prtActionButtonDescription: 'You can move this window freely',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PROMOTER_RATES_TABLE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    prtActionButton: 'Tasa SPOT',
    prtActionButtonDescription: 'Puedes mover esta ventana libremente',
  },
};

export default PROMOTER_RATES_TABLE_LABELS;
